/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Status_View_SubmissionInputs */



/**
* | output |
* | --- |
* | "View submission" |
*
* @param {Twda_Status_View_SubmissionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_status_view_submission = /** @type {((inputs?: Twda_Status_View_SubmissionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Status_View_SubmissionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir la soumission")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver el envío")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ver o envio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza l'invio")
	return /** @type {LocalizedString} */ ("View submission")
});